import { makeStyles } from "tss-react/mui"
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material"
import { BillReceiversType } from "../billReceiversTypes"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    root: {
        width: "100%",
        marginTop: "1rem",
    },
    card: {
        padding: "2rem",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        borderRadius: "0.75rem",
        border: `1px solid ${theme.palette.tailwind.slate[200]}`,
        justifyContent: "space-between",
    },
    checkedCard: {
        backgroundColor: theme.palette.tailwind.green[50],
        border: `1px solid ${theme.palette.tailwind.green[50]}`,
    },
    cardSubtitle: {
        marginTop: "1.5rem",
        fontSize: "0.875rem",
        color: theme.palette.tailwind.slate[600],
    },
}))

export function CreateBillTypeSelect({
    selectedValue,
    handleChange,
}: {
    selectedValue: BillReceiversType | null
    handleChange: (e: SelectChangeEvent<BillReceiversType>) => void
}) {
    const { classes } = useStyles()

    return (
        <Box>
            <LocalizedStrict id="bill-receivers-create-dialog-customer-type">
                <Typography variant="subtitle1" textAlign="start">
                    Customer type:
                </Typography>
            </LocalizedStrict>
            <FormControl fullWidth variant="outlined" className={classes.root}>
                <InputLabel id="bill-receivers-select-type-label">
                    <LocalizedStrict id="bill-receivers-select-type">
                        <>Select type</>
                    </LocalizedStrict>
                </InputLabel>
                <Select
                    labelId="bill-receivers-select-type-label"
                    id="bill-receivers-select-type"
                    value={selectedValue ?? ""}
                    onChange={handleChange}
                    label="Select type"
                >
                    <MenuItem value={BillReceiversType.PRIVATE_PERSON}>
                        <LocalizedStrict id="bill-receivers-select-private-person">
                            <Typography>Private person / association</Typography>
                        </LocalizedStrict>
                    </MenuItem>
                    <MenuItem value={BillReceiversType.PUBLIC_INSTITUTION}>
                        <LocalizedStrict id="bill-receivers-select-public-institution">
                            <Typography>Public institution</Typography>
                        </LocalizedStrict>
                    </MenuItem>
                    <MenuItem value={BillReceiversType.PRIVATE_COMPANY}>
                        <LocalizedStrict id="bill-receivers-select-private-company">
                            <Typography>Private company</Typography>
                        </LocalizedStrict>
                    </MenuItem>
                </Select>
            </FormControl>
        </Box>
    )
}
